import { defineStore } from 'pinia';
import { storePreffix } from '@/store/index';

export const loginStoreId = `${storePreffix}login`;

// eslint-disable-next-line import/prefer-default-export
export const useLoginStore = defineStore(loginStoreId, {
  state: () => ({
    token: {},
    profilerId: {},
  }),
  persist: true,
  getters: {
    FORMATTED_TOKEN: (state) => state.token && `${state.token.token_type} ${state.token.access_token}`,
    done: (state) => !!state.token,
  },
  actions: {
    async doLogin({
      token, profilerId,
    }) {
      this.token = token;
      this.profilerId = profilerId;
      if (!this.profilerId) {
        throw new Error('error');
      }
    },
    doLogout() {
      this.$reset();
    },
  },
});
